import React, { useEffect, useState } from "react";
import "./AlarmPalsPrivacy.css"

const AlarmPalsPrivacyPolicy = () => {

    //Check Mobile
    const [mobile, setMobile] = useState(false)
  
    useEffect(()=>{
     const checkIsMobile =() =>{
        setMobile(window.innerWidth < 768)
     }
  
     checkIsMobile();
  
    window.addEventListener('resize', checkIsMobile);
  
    return () => {
      window.removeEventListener('resize', checkIsMobile);
      
    };
    },[])
  
  
    return (
        <div className="policy-div">
          <h1>Alarm Pals</h1>
          <h2>Privacy Policy</h2>
          <p>
            This privacy policy governs your use of the application AlarmPals (“Application”) for mobile devices that was created by ThePalUniverse. The Application is a basic alarm clock application with notification permissions.
          </p>
          <p>
            The Application does not collect any personal data or sensitive information from its users. We do not require you to sign up for an account or provide any personal details to use the Application.
          </p>
          <p>
            The Application may require access to your phone's notification permission solely for the purpose of setting and managing alarms. We do not access or store the content of your notifications.
          </p>
          <p>
            The Application uses RevenueCat for in-app purchases. RevenueCat may collect certain information necessary to process in-app purchases, such as your device ID and purchase history. Please review RevenueCat's <a href="https://www.revenuecat.com/privacy">Privacy Policy</a> for more information.
          </p>
          <p>
            The Application does not use cookies or similar tracking technologies.
          </p>
          <p>
            We do not retain any user information beyond what is necessary for the functioning of the Application.
          </p>
          <p>
            The Application is not directed to children under the age of 13, and we do not knowingly collect personal information from children. If you are a parent or guardian and become aware that your child has provided us with personal information, please contact us immediately at ThePalUniverse@gmail.com and we will take steps to remove such information from our systems.
          </p>
          <p>
            If you have any questions or concerns about this Privacy Policy or our privacy practices, please contact us at ThePalUniverse@gmail.com.
          </p>
          <p>
            By using the Application, you agree to the terms and conditions of this Privacy Policy. If you do not agree with any part of this Privacy Policy, please do not use the Application.
          </p>
          <p>

          </p>
        </div>
      );
    };
    
  export default AlarmPalsPrivacyPolicy